var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/_Uint8Array.js
// module id = 57
// module chunks = 0